module.exports = __webpack_public_path__ + "static/media/burberry.0e2823bf.jpg";